import React from 'react';
import AppImages from '../assets/appImages1.webp';
import Technology from '../assets/technology.png';
import Sharing from '../assets/sharing.png';
import Network from '../assets/network.png';
import Membership from '../assets/membership.png';
import '../App.css';

const whatText = "Gridspot is your trusted partner in EV charging, offering comprehensive products and services tailored to meet the needs of multifamily and mixed-use properties. We offer commercial EV chargers as well as installation, maintenance and repair services.  We work hard to keep your EV chargers dependable and operational through proactive monitoring and support. Our innovative, cost-effective solutions are designed to make EV charging hassle-free, allowing property owners to enhance tenant satisfaction and attract eco-conscious residents. With Gridspot, you gain a reliable partner dedicated to making EV charging infrastructure accessible, functional, and stress-free.";

const reasons = [
  {image:Membership, title:"Easy Installation", text:"Install it yourself for DIY landlords—or let us handle it and avoid the hassle. Also check out our fully managed service option, which includes everything from installation to ongoing support. Whether you want full control or zero effort, Gridspot makes it easy to get EV charging up and running at your property."},
  {image:Network, title:"Fast, Reliable Charging", text:"Gridspot chargers deliver fast, reliable Level 2 charging at up to 11.5 kW. Tenants can count on consistent performance, with minimal downtime and dependable uptime monitoring. Our chargers are built with high-quality components and tested for real-world durability.  Gridspot keeps EVs ready to go."},
  {image:Sharing, title:"Enhanced Tenant Satisfaction", text:"Enhance tenant satisfaction by offering convenient, on-site EV charging—show your residents you care about sustainability, modern amenities, and making their lives easier every day. Gridspot chargers give tenants the peace of mind that they can charge where they live, without hunting for public stations. It's a small upgrade that delivers big value in retention, reputation, and resident happiness."},
  {image:Technology, title:"Simple Pricing", text:"Purchase our EV Chargers at a flat rate in our store or use our managed charging service for a fixed $350/month/charger cost. Note: $1.00/credit card transaction cost paid by users to cover cloud and transaction fees when using the Gridspot network.  Gridspot allows you to budget confidently, and know exactly what you're paying each month with no surprises or variable costs."},
];

export default function WhatWhy() {
  return (
    <>
      <section className="section">
        <div className="container split">
          <div>
            <h2>What Is Gridspot?</h2>
            <p className="lead">{whatText}</p>
          </div>
          <img className="split-phones" src={AppImages} alt="Gridspot app showing a charger map and the login screen" loading="lazy" width="900" height="1260"/>
        </div>
      </section>
      <section className="section section-tint">
        <div className="container">
          <div className="section-head">
            <h2>Why Gridspot?</h2>
            <p className="lead">Get a Gridspot Charger to Offer Convenient, Reliable EV Charging and Boost Your Property's Appeal and Value!</p>
          </div>
          <div className="why-grid">
            {reasons.map(r => (
              <article className="card why-card" key={r.title}>
                <img src={r.image} alt="" loading="lazy" width="1148" height="416"/>
                <div className="why-card-body">
                  <h3>{r.title}</h3>
                  <p>{r.text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
